import React, { Fragment, useState, useEffect } from 'react';
import DistributionDataTable from './DistributionDataTable';

const DistributionData = ({ accountingData }) => {

    const [distributionDataAcc, setDistributionDataAcc] = useState([]);

    useEffect(() => {
        getListDistributionData();
    }, []);

    const getListDistributionData = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cajas-contables/listar-distribucion', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(response => {
            setDistributionDataAcc(response);
        }).catch(err => {
            console.error(err);
            setDistributionDataAcc([]);
        });
    }

    const sendAccountingAccountToDistribution = async (dataAcc, dataDist) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cajas-contables/vincular-distribucion', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_caja_contable: dataAcc,
                id_caja_contable_distribucion: dataDist.id_caja_contable_distribucion
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(response => {
            getListDistributionData();
        }).catch(err => {
            console.error(err);
        });
    }

    const DataTableDistribution = () => {
        return (
            <DistributionDataTable
                reactTableData={distributionDataAcc}
                accountingData={accountingData}
                sendAccountingAccountToDistribution={sendAccountingAccountToDistribution}
            />);
    }

    return (
        <Fragment>
            <DataTableDistribution />
        </Fragment>
    );
}

export default DistributionData;
